// extracted by mini-css-extract-plugin
export default {"stepsContainer":"StepsNavigation_stepsContainer__tzX8j","step":"StepsNavigation_step__94G0c","activeStep":"StepsNavigation_activeStep__po0SV"};